import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Logout14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_145)'>
      <path
        d='M6.11617 0.823209C6.60433 0.335053 7.39578 0.335053 7.88394 0.823209L13.1768 6.1161C13.665 6.60426 13.665 7.39571 13.1768 7.88387L7.88394 13.1768C7.39578 13.6649 6.60433 13.6649 6.11617 13.1768L3.46973 10.5303L4.53039 9.46966L7.00006 11.9393L11.9394 6.99999L7.00006 2.06065L4.53039 4.53032L3.46973 3.46966L6.11617 0.823209Z'
        fill='currentColor'
      />
      <path
        d='M2.5 6.25H9V7.75H2.5V9.5L0 7L2.5 4.5V6.25Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_145'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Logout14.displayName = 'Logout14';
export default Logout14;
